import { BrandingState, InitBrandingState } from './branding.state';
import {
    BRANDING_LOAD_4SIGMA,
    BRANDING_LOAD_CUSTOM_BRANDING,
    BRANDING_LOAD_DEFAULT,
    BRANDING_REMOVE_ALL,
    BrandingAction
} from './branding.action';
import { FAQ_LINK_ENABLED } from '../faq-link.config';

export function brandingReducer(state: BrandingState = new InitBrandingState(), action: BrandingAction): BrandingState {
    switch (action.type) {
        case BRANDING_LOAD_CUSTOM_BRANDING: {
            const branding = <BrandingState>action.payload;
            return FAQ_LINK_ENABLED ? branding : { ...branding, faqLink: false };
        }
        case BRANDING_REMOVE_ALL:
        case BRANDING_LOAD_DEFAULT: {
            return new InitBrandingState();
        }
        default: {
            return state;
        }
    }
}
